import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { styled } from '@egoist/vue-emotion'
import * as getters from '../../../../builder/src/js/store/modules/getters'
import * as actions from '../../../../builder/src/js/store/modules/actions'
import * as constants from '../../../../builder/src/js/common/constants/constants'
import { mapGetters, mapState, mapActions } from 'vuex'

import CvtButton from '../../molecules/Button'

Vue.use(VueI18n)

let textFontWeight, textFontSize, Spacing, FontSize, backgroundColor, Colors

const getAuthenticateContainer = () => styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const getAuthenticateHelpText = () => styled('p')`
  font-size: 12px;
  margin: 0;
`

const getAuthenticationDescription = () => styled('div')`
  background: ${Colors.BASIC[100]};
`

const getHorizontalLine = () => styled('div')`
  border-top: 1px solid ${Colors.BASIC[300]};
  margin-bottom: 15px;
`

const getIntegrationTitle = () => styled('p')`
  font-size: 14px;
`

const getIntegrationUseWrap = () => styled('div')`
  font-size: 14px;
`

const getIntegrationUseSubtext = () => styled('p')`
  font-size: 14px;
`

export const IntegrationDescription = {
  name: 'IntegrationDescription',
  components: {},
  data() {
    return {}
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters({
      config: getters.AUTH_GET_USER_CONFIG,
      selectedIntegration: getters.SELECTED_INTEGRATION,
    }),
    ...mapGetters('globalTheme', {
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
    }),
    ...mapState('globalTheme', {
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontSize: ({ globalTheme }) => globalTheme.FontSize,
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      globalTheme: ({ globalTheme }) => globalTheme,
    }),
  },
  created() {
    textFontSize = this.textFontSize
    textFontWeight = this.textFontWeight
    Spacing = this.Spacing
    FontSize = this.FontSize
    backgroundColor = this.backgroundColor
    Colors = this.Colors
  },
  mounted() {
    this.onScrollInToView()
  },
  methods: {
    ...mapActions('globalTheme', {}),
    ...mapActions({
      onChangeStep: actions.UPDATE_INTEGRATIONS_AUTH_STEP,
      onChangeScreen: actions.UPDATE_INTEGRATIONS_CURRENT_SCREEN,
    }),

    onScrollInToView() {
      const container = document.getElementById('authWrap')
      container.scrollIntoView()
    },

    onChangeAuthStep(step: string) {
      this.onChangeStep(step)
      this.onScrollInToView()
    },
  },
  render: function (h) {
    const AuthenticateContainer = getAuthenticateContainer()
    const AuthenticateHelpText = getAuthenticateHelpText()
    const AuthenticationDescription = getAuthenticationDescription()
    const HorizontalLine = getHorizontalLine()
    const IntegrationTitle = getIntegrationTitle()
    const IntegrationUseWrap = getIntegrationUseWrap()
    const IntegrationUseSubtext = getIntegrationUseSubtext()

    const integrationTitle = this.selectedIntegration.title

    return (
      <AuthenticationDescription>
        <div>
          <div style="padding: 45px 45px 0 45px;">
            <IntegrationTitle>
              {integrationTitle}{' '}
              {this.$t('builder.integrations.description.google.sheets.header')}
            </IntegrationTitle>
            <IntegrationUseWrap>
              <p>Use this integration to</p>
              <ul>
                <li>
                  Add form data to your spreadsheets
                  {this.$t('builder.integrations.description.list.one')}
                </li>
                <li>
                  Automate your workflow
                  {this.$t('builder.integrations.description.list.two')}
                </li>
                <li>
                  Cut out manual data entry
                  {this.$t('builder.integrations.description.list.three')}
                </li>
              </ul>
            </IntegrationUseWrap>
            <IntegrationUseSubtext>
              {/* New form data will be sent to your spreadsheets instantly so
                  you and your team can view and analyze it right away. Just
                  create your form, customize to your liking, and integrate to
                  start collecting responses in Google Sheets today, */}
              {this.$t('builder.integrations.description.subtext')}
            </IntegrationUseSubtext>
            <IntegrationUseSubtext>
              {/* Learn how to */}
              {this.$t('builder.integrations.description.list.one')}
              <span style="text-decoration: underline;cursor: pointer;">
                {' '}
                integrate your form with {integrationTitle}.
              </span>
            </IntegrationUseSubtext>
          </div>
          <div style="padding: 15px 45px 40px;">
            <HorizontalLine></HorizontalLine>
            <p style="font-weight: 700;padding-top:10px;font-size: 14px;">
              Authentication
            </p>
            <AuthenticateContainer>
              <AuthenticateHelpText>
                Authenticate your {integrationTitle} account in order to create
                an integration.
              </AuthenticateHelpText>
              <CvtButton
                text="AUTHENTICATE"
                outlined={true}
                specialPadding="12px"
                color="success"
                onClick={() => this.onChangeAuthStep(constants.AUTH_SUCCESS)}
              ></CvtButton>
            </AuthenticateContainer>
          </div>
        </div>
      </AuthenticationDescription>
    )
  },
}
